<template>
  <div class="section-box">
    <el-row type="flex" class="score-row-bg">
      <el-col :span="12">
        <div>试卷名称：{{form.spaperName}}</div>
      </el-col>
      <el-col :span="12">
        <div>考试类型：课程考试</div>
      </el-col>
    </el-row>
    <QueryList ref="query"/>
  </div>
</template>

<script>
import QueryList from './index/queryList'
export default {
  components: {
    QueryList
  },
  data() {
    return {
      form: {
        spaperName: '',
        npaperAttribute: '',
        spaperNo: '',
      }
    }
  },
  beforeRouteEnter (to, from, next) {
    next(vm => {
      if (!vm.$route.query.spaperNo) {
        vm.$message.warning('缺少此考试编码')
        setTimeout(() => {
          vm.removeTabList({
            id: vm.$route.meta.menuId,
          })
          vm.$router.push('/examination/course')
        }, 300)
      } else {
        vm.form.spaperNo = vm.$route.query.spaperNo
        vm.form.spaperName = vm.$route.query.name
        vm.form.npaperAttribute = vm.$route.query.attribute
      }
    })
  },
}
</script>

<style lang="scss">
.score-row-bg {
  padding: 14px 0;
  background-color: #f9fafc;
  margin-bottom: 30px;
  .el-col {
    padding-left: 20px;
    text-align: left;
    div {
      font-size: 17px;      
      font-weight: bold;
      color: #111111;
    }
  }
}
</style>